module.exports = __webpack_public_path__ + "img/boxing.7598d756.svg";